import type { Router } from 'vue-router'
import { PushNotifications } from '@capacitor/push-notifications'
import { isNativePlatform } from '@/utils/platform'
import { resolveNotificationRoute } from '@/utils/notificationRoutes'

export function registerPushTapHandler(router: Router): void {
  if (!isNativePlatform) return

  PushNotifications.addListener('pushNotificationActionPerformed', ({ notification }) => {
    const path = resolveNotificationRoute(notification.data ?? {})
    router.push(path)
  })
}
